import Vue from 'vue'
import { Axios, EventManager } from '../utils'

require('./components')

const Slideshow = new Vue({
	created() {
		this.fetchSlideshows()

		// Fetch all available slides for the current slideshow
		// Fetch settings informtion for the current slideshow
		// Fetch all available themes
	},
	methods: {

		// emit the data to the Event object. Child components
		// can pick it up from there
		fetchSlideshows() {
			Axios.get('/metaslider/v1/slideshows/all').then(response => {
				EventManager.$emit('allSlideshows', response.data)
				console.log('All Slideshows', response.data)
			}).catch(error => {
				console.log(error.response.data)
			})
		}
	}
}).$mount('#metaslider-ui')

export default Slideshow



// WEBPACK FOOTER //
// ./src/admin/assets/js/app/slideshows/slideshow.js